import { gql } from '@apollo/client';
import { VideoType } from '../../common/helpers/domain/videoTypes';
import { PostProject } from '../contentPage/postDetail';
import { Tag } from '../fragments/project';
import { PostSubcategory } from '../../common/helpers/domain/postCategories';

export const POST_LIST_QUERY = gql`
  query PostList(
    $propertyType: [String]
    $offset: Int
    $perPage: Int
    $postCategory: [String]
    $videoType: [String]
    $termsTaxonomy: String
    $termsSlug: String
    $exclude: [Int]
  ) {
    posts(
      request: {
        terms: { taxonomy: $termsTaxonomy, slug: $termsSlug }
        propertyType: $propertyType
        offset: $offset
        perPage: $perPage
        custom: { postCategory: $postCategory, videoType: $videoType }
        exclude: $exclude
      }
    ) {
      totalCount
      totalPage
      items {
        id
        title
        propertyType
        author {
          id
          name
        }
        link
        postCategory
        videoType
        featuredImage {
          url
        }
        embedVideo
        tags {
          name
        }
        project {
          id
          name
          propertyType
          developer
          location {
            zone {
              label
              value
              link
              parent {
                value
                label
                link
              }
            }
            district {
              label
              value
              link
              parent {
                value
                label
                link
              }
            }
            road {
              label
              value
              link
              parent {
                value
                label
                link
              }
            }
          }
          transportations {
            value
            label
            link
          }
          priceTypes {
            starting_price
            level {
              value
              label
            }
          }
        }
      }
    }
  }
`;

export interface PostListQueryData {
  posts: {
    totalCount: number;
    totalPage: number;
    items: PostListItem[];
  };
}

export interface PostListItem {
  id: number;
  title: string;
  link: string;
  author: {
    id: number;
    name: string;
  };
  propertyType: string[];
  postCategory: PostSubcategory;
  videoType: VideoType;
  featuredImage: {
    url: string;
  };
  embedVideo: string;
  tags: Tag[];
  project: PostProject;
}
